angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "LEAVE_REVIEW": {
    "HEADER_GUIDE": "Please leave a review about your guest and your tour",
    "HEADER_GUEST": "Please leave a review about your local host and your tour",
    "INFO_TEXT": "Your reviews are critically important in making Showaround a credible and trustworthy community. Help both locals and guests by sharing a sincere review.",
    "RATING_LABEL": "Rating",
    "CONTENT_LABEL_GUIDE": "Review (on guest profile)",
    "CONTENT_LABEL_GUEST": "Review (on local host profile)",
    "CONTENT_PLACEHOLDER_GUIDE": "Share some feedback about your guest and your tour experience.",
    "CONTENT_PLACEHOLDER_GUEST": "Share some feedback about your host and your tour experience.",
    "FEEDBACK_LABEL": "Private feedback to Showaround (optional)",
    "FEEDBACK_PLACEHOLDER": "Is there anything about your tour experience that you’d like to share with Showaround privately?"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/translations/leave_review.json
// module id = 431
// module chunks = 24